import { RawAxiosRequestHeaders } from 'axios'
import { axiosInstance } from './config'
import { getAuthToken } from './utils'

export const getPaginatedFirms = async (skip: number,  limit: number, name: string, location: string[]) => {
    const headers: RawAxiosRequestHeaders = {}
    const token = getAuthToken({ bearerPrefix: true })
    token && (headers.authorization = token)
    const params = {
      skip,
      limit,
      country: location[0],
      state: location[1],
      name: name.trim() !== "" ? name : undefined,// Handle empty string
    };
    const res = await axiosInstance.get('/firms/paginated', { params: params,headers: headers})
    return res
  }